import React from 'react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { INSIGHTS, OLLIE_IMAGES } from '../data/mock';
import { BookOpen, ArrowRight, Clock } from 'lucide-react';

export const InsightsSection = () => {
  return (
    <section id="insights" className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-12 gap-4">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Energy Insights
            </h2>
            <p className="text-lg text-gray-600 max-w-xl">
              Learn more about smart home energy solutions
            </p>
          </div>
          <Button
            variant="outline"
            className="border-cyo-orange text-cyo-orange hover:bg-cyo-orange hover:text-white self-start md:self-auto"
          >
            View All Guides
            <ArrowRight className="w-4 h-4 ml-2" />
          </Button>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {INSIGHTS.map((insight) => (
            <Card
              key={insight.id}
              className="bg-white border-0 rounded-2xl shadow-sm hover:shadow-lg transition-all duration-300 cursor-pointer group overflow-hidden"
            >
              <CardContent className="p-0">
                {/* Image placeholder */}
                <div className="h-40 bg-gradient-to-br from-orange-100 to-orange-50 flex items-center justify-center">
                  <BookOpen className="w-12 h-12 text-cyo-orange/40" />
                </div>

                <div className="p-6">
                  {/* Category badge */}
                  <span className="text-xs font-medium text-cyo-orange bg-orange-50 px-2 py-1 rounded-full">
                    {insight.category}
                  </span>

                  {/* Title */}
                  <h3 className="text-lg font-semibold text-gray-900 mt-3 mb-2 group-hover:text-cyo-orange transition-colors">
                    {insight.title}
                  </h3>

                  {/* Excerpt */}
                  <p className="text-gray-500 text-sm mb-4">
                    {insight.excerpt}
                  </p>

                  {/* Read time */}
                  <div className="flex items-center text-gray-400 text-sm">
                    <Clock className="w-4 h-4 mr-1" />
                    {insight.readTime}
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Ollie reading - subtle */}
        <div className="mt-12 text-center">
          <img
            src={OLLIE_IMAGES.reading}
            alt="Ollie reading about energy"
            className="w-24 h-24 mx-auto opacity-60 hover:opacity-100 transition-opacity"
          />
        </div>
      </div>
    </section>
  );
};
